import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b8e76c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0 2vw"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_3 = { style: {"width":"94%"} }
const _hoisted_4 = { class: "img-item" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "img-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      error: _ctx.error,
      "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
      "error-text": "请求失败，点击重新加载",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_row, { justify: "space-between" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (img) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "12",
                key: img.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          style: {"width":"100%","height":"auto"},
                          src: img.thumb
                        }, null, 8, _hoisted_5),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(img.imgName), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_van_col, { span: "11" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "finished", "error", "onLoad"])
  ]))
}